export default __webpack_public_path__ + "media/img/main-88368679bdefd6429bb990526bd17159.svg";